module.exports = [
	"Beta test",
	"New Name",
	"4-LOM",
	"Aayla Secura",
	"Admiral Ackbar",
	"Admiral Thrawn",
	"Ahsoka Tano",
	"Anakin Solo",
	"Asajj Ventress",
	"Aurra Sing",
	"Senator Bail Organa",
	"Barriss Offee",
	"Bastila Shan",
	"Ben Skywalker",
	"Bib Fortuna",
	"Biggs Darklighter",
	"Boba Fett",
	"Bossk",
	"Brakiss",
	"C-3PO",
	"Cad Bane",
	"Cade Skywalker",
	"Callista Ming",
	"Captain Rex",
	"Carnor Jax",
	"Chewbacca",
	"Clone Commander Cody",
	"Count Dooku",
	"Darth Bane",
	"Darth Krayt",
	"Darth Maul",
	"Darth Nihilus",
	"Darth Vader",
	"Dash Rendar",
	"Dengar",
	"Durge",
	"Emperor Palpatine",
	"Exar Kun",
	"Galen Marek",
	"General Crix Madine",
	"General Dodonna",
	"General Grievous",
	"General Veers",
	"Gilad Pellaeon",
	"Grand Moff Tarkin",
	"Greedo",
	"Han Solo",
	"IG 88",
	"Jabba The Hutt",
	"Jacen Solo",
	"Jaina Solo",
	"Jango Fett",
	"Jarael",
	"Jerec",
	"Joruus C'Baoth",
	"Ki-Adi-Mundi",
	"Kir Kanos",
	"Kit Fisto",
	"Kyle Katarn",
	"Kyp Durron",
	"Lando Calrissian",
	"Luke Skywalker",
	"Luminara Unduli",
	"Lumiya",
	"Mace Windu",
	"Mara Jade",
	"Mission Vao",
	"Natasi Daala",
	"Nom Anor",
	"Obi-Wan Kenobi",
	"Padmé Amidala",
	"Plo Koon",
	"Pre Vizsla",
	"Prince Xizor",
	"Princess Leia",
	"PROXY",
	"Qui-Gon Jinn",
	"Quinlan Vos",
	"R2-D2",
	"Rahm Kota",
	"Revan",
	"Satele Shan",
	"Savage Opress",
	"Sebulba",
	"Shaak Ti",
	"Shmi Skywalker",
	"Talon Karrde",
	"Ulic Qel-Droma",
	"Visas Marr",
	"Watto",
	"Wedge Antilles",
	"Yoda",
	"Zam Wesell",
	"Zayne Carrick",
	"Zuckuss"
];


//////////////////
// WEBPACK FOOTER
// ./src/starwars-names.json
// module id = 0
// module chunks = 0